import React,  {Component, PropTypes } from 'react'
import CoverCell from '../../shared/covercell.js'
import DateCell from '../../shared/DateCell.jsx'
import StarCell from '../../shared/StarCell.jsx'
import LivreCell from '../../shared/LivreCell.jsx'




const LivreForAuteur = ( props ) => {
    //console.log(edition.edition);
    let nbrCritString = '';
    if (props.nbr > 1){
        nbrCritString = ' (' + props.nbr + ' critiques)';
    }
    if (props.nbr === 1){
        nbrCritString = ' (' + props.nbr + ' critique)';        
    }
    return (
        <div className="row">
            <div>
                <div className="media-left">
                    <CoverCell  cover={props.cover} href={'/i.php/vcrit/' + props.livreid} size={'S'} />                
                </div>
                <div className="media-body">
                    <div className="media-heading">
                        <a href={'/i.php/vcrit/' + props.livreid}>
                            <span style={{'fontWeight': 'bold'}}>{props.titrelivre}</span> {props.titreorig ? ' ( ' + props.titreorig +')' : null }
                        </a>
                    </div>
                    <div className="row">
                    <div className="col-sm-12 col-md-8">
                        <LivreCell {...props} />
                        {props.nbr > 0 && (
                        <div>
                            Critiqué par <a href={'/i.php/vuser/' + props.uid}>{props.pseudo}</a> le <DateCell date={props.cdate} />
                        </div>
                        )
                    }
                    </div>
                    {props.nbr > 0 && (
                    <div className="col-sm-6 col-md-4">
                        <StarCell small={1} star={props.star} /> {nbrCritString}
                    </div>
                    )}
                </div>
                    
                    
                </div>
            </div>
            {/* not implemented
            <div className="col-md-4">
                Amazon
                <br/>Livre en poche
                <br/>Mes listes
                <br/>Biblio
            </div>
            */}

        </div>
    )
}


LivreForAuteur.PropTypes = PropTypes.shape({
        'amz_img_l': PropTypes.string,
        'amz_img_m': PropTypes.string,
        'amz_img_s': PropTypes.string,
        'cover': PropTypes.shape({
            'L' : PropTypes.shape({
                'cover_url': PropTypes.string,
                'is_local' : PropTypes.number
            }),
            'S' : PropTypes.shape({
                'cover_url': PropTypes.string,
                'is_local' : PropTypes.number
            }),
            'M' : PropTypes.shape({
                'cover_url': PropTypes.string,
                'is_local' : PropTypes.number
            }),
        }),
        'cdate' : PropTypes.string,
        'isbn' : PropTypes.string,
        'asin' : PropTypes.string,
        'livreid' : PropTypes.number,
        'ownedbook': PropTypes.number,
        'titre' : PropTypes.string,
        'titrelivre': PropTypes.string,
        'titreorig': PropTypes.string,
        'pseudo': PropTypes.string,
        'uid': PropTypes.string,
        'nbr': PropTypes.number,
        'star': PropTypes.number,
        'editeur' : PropTypes.number,
        'editeur_nom' : PropTypes.string,
        'collection' : PropTypes.string
    });

export default LivreForAuteur


// WEBPACK FOOTER //
// ./auteur/livres/LivreForAuteur.js